import React from "react";

const ShowMore = (props) => {
  //  const [show, setShow] = React.useState(false);


    return (
        <div className="show-more" onClick={props.onClick}>Show More</div>
    );
};

export default ShowMore;